const CONSTANTS = {
  REGEX: {
    PASSWORD: new RegExp(
      /^(?=.*[a-zA-Z])(?=.*\d)(?=.*[!@#$%^&*])[a-zA-Z\d!@#$%^&*]{8,}$/
    ),
  },
}

export default CONSTANTS
